export type TPartscareIneligibleReason =
  | 'part_not_eligible'
  | 'unknown_part_type'
  | 'mileage_unknown'
  | 'no_part_price'
  | 'scope_not_eligible'
  | 'part_price_too_low'

export interface IPartscareQuote {
  orderId: string
  orderItemId: number

  partName: string | null
  partTypeCode: string | null
  vehicle: string | null
  partPrice: number | null
  mileage: number | null

  eligible: boolean
  ineligibleReason: TPartscareIneligibleReason | null

  ratePercent: number | null
  coverageYears: number | null
  monthlyAmount: number | null
  currency: string | null

  clampedToMinimum: boolean
  clampedToMaximum: boolean

  alreadyHasPartscare: boolean
  publishableKey: string | null

  /** Enrolment closes this long after purchase; past it checkout is refused. */
  offerExpiresAt: string | null
  offerExpired: boolean
}

export interface IPartscareCheckoutSession {
  clientSecret: string
  checkoutSessionId: string
  publishableKey: string
  monthlyAmount: number
  currency: string
  coverageYears: number
}

export interface IPartscarePortalSession {
  /** Single-use Stripe Customer Portal URL. Redirect to it immediately. */
  url: string
}

export interface IPartscareSessionStatus {
  status: 'open' | 'complete' | 'expired' | string
  paymentStatus: string | null
  customerEmail: string | null
  subscriptionId: string | null
  monthlyAmount: number | null
  currency: string | null
  coverageYears: number | null
  partscareActive: boolean
}

// --
// -- Copy for the cases where a part cannot be covered.
// --
export const PARTSCARE_INELIGIBLE_MESSAGE: Record<TPartscareIneligibleReason, string> = {
  part_not_eligible: 'This part is not eligible for PartsCare.',
  unknown_part_type: 'This part is not eligible for PartsCare.',
  mileage_unknown:
    'We need the vehicle mileage on file before PartsCare can be quoted for this part. Please contact customer service.',
  no_part_price: 'We could not determine a selling price for this part, so PartsCare cannot be quoted.',
  // PartsCare is not sold on this store yet; the customer does not need the detail.
  scope_not_eligible: 'This part is not eligible for PartsCare.',
  // A business rule, not something the customer can act on.
  part_price_too_low: 'This part is not eligible for PartsCare.',
}
